import '@fancyapps/fancybox'
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'
import { dispatchAjaxContentLoaded } from './generic/evented'
import { ModelViewerCollection } from './ModelViewer'

export default class Modals {
  els = {
    closeFancyBtn: '[data-js-fancy-close]',
    open3dModel: '[data-js-open-3d-modal]'
  }

  modals = [{
    selector: '.popup-gallery', options: {
      delegate: 'a', type: 'image', gallery: {
        enabled: true, navigateByImgClick: true, preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
      },
    }
  }, {
    selector: '.popup-modal', options: {
      modal: false, type: 'inline',
    },
  }, {
    selector: '[data-js-fancy-single]', options: {
      loop: false,
      buttons: [
        'close'],
      infobar: false,
      transitionEffect: 'fade',
      touch: false,
      helpers: {
        overlay: {
          locked: false
        }
      },
      width: '2000%',
      height: '2000%',
    }
  }]

  constructor () {
    this.scrollPosition = 0;
    this.init()
    this.bindEvents()
  }

  closeActiveFancyBox ({ target }) {
    if (target.dataset.hasOwnProperty('jsFancyClose')) {
      $.fancybox.close()
    }
  }

  init () {
    this.modals.forEach(function (item) {
      $(item.selector).each(function () {
        $(this).fancybox(item.options)
      })
    })
  }

  static openAjaxModal (src, ajaxSettings = {}) {
    $.fancybox.open({
      src: src, type: 'ajax', opts: {
        modal: false,
        autoFocus: false,
        touch: false,
        type: 'inline',
        ajax: ajaxSettings,
        afterLoad: function (instance, current) {
          current.$content.css('display', 'inline-block')

          dispatchAjaxContentLoaded({
            content: this.$content
          })
        }
      }
    })
  }

  static openHtmlModal(htmlContent, fancyboxOptions = {}) {
    $.fancybox.open({
      src: htmlContent,
      type: 'html',
      options: {
        buttons: ['close'],
        clickOutside: 'close',
        clickSlide: 'close',
        animationEffect: 'fade',
        touch: false,
      },
      ...fancyboxOptions,
    });
  }

  static open3DModelModal(modelConfig = {}) {
    const modelViewer = ModelViewerCollection.createModelViewer(modelConfig);
    const $tempContainer = $('<div></div>');
    $.fancybox.open({
      src: $tempContainer.html(),
      type: 'html',
      opts: {
        modal: false,
        autoFocus: false,
        touch: false,
        afterLoad: function (instance, current) {
          current.$content.css('display', 'inline-block');
          current.$content.append(modelViewer);
          dispatchAjaxContentLoaded({
            content: this.$content,
          });
        },
      },
    });
  }

  bindEvents () {
    $(document).on('click', '.popup-modal-ajax', function (e) {
      e.preventDefault()

      const src = $(this).attr('data-src') || $(this).attr('href')
      Modals.openAjaxModal(src)
    })
    document.addEventListener('click', (e) => this.closeActiveFancyBox(e))

    $(document).on('ajaxContentLoaded', (e) => {
      this.init()
    })

    $(document).on('beforeShow.fb', () => {
      this.scrollPosition = document.body.scrollTop
    });

    $(document).on('click', '[data-js-open-3d-modal]', function (e) {
      e.preventDefault();
      const element = e.currentTarget;
      const modelConfig = JSON.parse(element.getAttribute('data-js-open-3d-modal'));
      Modals.open3DModelModal(modelConfig);
    });

    $(document).on('afterClose.fb', () => {
      Promise.resolve().then(() => {
        document.body.scroll(0,this.scrollPosition)
      })
    });
  }
}
